import React from 'react';
import { AlertCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Llegás a la clase sin saber exactamente qué ejercicio vas a dar hoy', 'Tus alumnas no progresan porque no tenés una secuencia clara de nivel a nivel', 'El 40% de tus alumnas abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Correcciones técnicas improvisadas en el agua, sin un método claro que te respalde', 'Alumnas de distintos niveles juntas y la clase se convierte en un caos', 'Fin de mes y las alumnas se van sin avisar porque no ven progresión en sus clases'];
  return <section className="py-10 md:py-20 bg-slate-50 border-y border-slate-200" data-id="element-223">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <FadeIn data-id="element-225">
          <div className="text-center mb-6 md:mb-12" data-id="element-226">
            <h2 className="text-2xl md:text-4xl font-display font-bold text-deepblue-900 mb-2 md:mb-4" data-id="element-227">
              Si sos instructora/or de aquagym en Argentina,{' '}
              <span className="text-rose-600" data-id="element-228">
                esto te va a sonar familiar:
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-2 md:space-y-4 mb-8 md:mb-16" data-id="element-229">
          {points.map((point, index) => <FadeIn key={index} delay={index * 0.05} direction="left" data-id="element-230">
              <div className="flex items-start gap-3 md:gap-4 bg-white p-3 md:p-5 rounded-lg md:rounded-xl shadow-sm border border-slate-100 hover:border-rose-200 hover:shadow-md transition-all group" data-id="element-231">
                <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full bg-rose-100 text-rose-600 font-display font-bold text-sm md:text-base flex items-center justify-center group-hover:bg-rose-600 group-hover:text-white transition-colors" data-id="element-232">
                  0{index + 1}
                </div>
                <p className="text-slate-700 font-medium pt-1 md:pt-2 text-sm md:text-lg" data-id="element-233">
                  {point}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-234">
          <div className="bg-rose-50 border-2 border-rose-200 rounded-xl md:rounded-2xl p-4 md:p-8 text-center" data-id="element-235">
            <AlertCircle className="w-8 h-8 md:w-12 md:h-12 text-rose-500 mx-auto mb-2 md:mb-4" data-id="element-236" />
            <h3 className="text-xl md:text-3xl font-display font-black text-rose-900" data-id="element-237">
              ¿Cuántas clases más vas a improvisar al borde de la pileta?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
}